import { useEffect, useRef, useState } from "react";
import { attachStream, type StreamKind } from "../adapters/static/direct-hls";

export interface PlayerProps {
  url: string;
  poster?: string;
  onClose?: () => void;
}

export function Player({ url, poster, onClose }: PlayerProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [error, setError] = useState<string | null>(null);
  const [kind, setKind] = useState<StreamKind | null>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    setError(null);
    let handle: ReturnType<typeof attachStream> | null = null;
    try {
      handle = attachStream(video, url);
      setKind(handle.kind);
      video.play().catch((e) => {
        // Autoplay may be blocked; user must click play
        if (e.name !== "AbortError") console.warn("play() failed:", e);
      });
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : "Failed to attach stream";
      setError(msg);
    }
    return () => {
      if (handle) handle.destroy();
    };
  }, [url]);

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000", zIndex: 100 }}>
      <video
        ref={videoRef}
        controls
        autoPlay
        playsInline
        poster={poster}
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
      />
      {error && (
        <div style={{ position: "absolute", top: 16, left: 16, color: "#fff", background: "#c00", padding: 12 }}>
          {error}
        </div>
      )}
      {kind && (
        <div style={{ position: "absolute", top: 16, right: 16, color: "#aaa", fontSize: 12 }}>
          {kind.toUpperCase()}
        </div>
      )}
      {onClose && (
        <button
          onClick={onClose}
          style={{ position: "absolute", bottom: 24, left: "50%", transform: "translateX(-50%)", padding: "8px 16px" }}
        >
          Close
        </button>
      )}
    </div>
  );
}
